<template>
  <highcharts ref="chart" :options="options"></highcharts>
</template>

<script>
import '@/plugins/highcharts.js'
import { outliersDetection } from '@/mixins/outliersDetection'

export default {
  name: 'GHGIsBoxPlot',
  mixins: [outliersDetection],
  props: {
    ghgis: {
      type: Array,
      default: null
    },
    modules: {
      type: Array,
      default: function () {
        return []
      }
    },
    colors: {
      type: Object
    }
  },
  computed: {
    series: function () {
      let series = [
        {
          data: []
        },
        {
          data: [],
          type: 'scatter',
          marker: {
            symbol: 'circle'
          },
          opacity: 0.5,
          tooltip: {
            pointFormat:
              '<strong>{point.labName}</strong>: {point.intensity} ' +
              this.$t('t.co2e')
          }
        },
        {
          data: [],
          type: 'scatter',
          marker: {
            symbol: 'circle'
          },
          opacity: 0.5,
          tooltip: {
            pointFormat:
              '<strong>{point.labName}</strong>: {point.intensity} ' +
              this.$t('t.co2e')
          }
        }
      ]
      let index = 0
      let outliersData = []
      let othersData = []
      for (let module of this.modules) {
        this.detectOutliers(
          this.ghgis.map(
            (ghgi) =>
              ghgi.carbonSynthesis[module].intensity /
              1000 /
              ghgi.boundary.workforce
          )
        )
        let data = []
        let high = 0
        let low = 999999999999999
        for (let ghgi of this.ghgis) {
          let val = ghgi.carbonSynthesis[module].intensity
          // in tons per capita
          val = val / 1000 / ghgi.boundary.workforce
          let logVal = Math.log(val + 1)
          if (logVal > high) {
            high = logVal
          }
          if (logVal < low) {
            low = logVal
          }
          let randX = index + this.randomValue()
          if (this.isOutlier(val)) {
            outliersData.push({
              x: randX,
              y: val,
              labName: ghgi.entity.name,
              intensity: Math.round(val * 100) / 100,
              color: this.colors[module]
            })
          } else {
            data.push(val)
            othersData.push({
              x: randX,
              y: val,
              labName: ghgi.entity.name,
              intensity: Math.round(val * 100) / 100,
              color: this.colors[module]
            })
          }
        }
        series[0].data.push({
          low: Math.round(Math.min(...data) * 100) / 100,
          q1: Math.round(this.quantile(data, 0.25) * 100) / 100,
          median: Math.round(this.quantile(data, 0.5) * 100) / 100,
          q3: Math.round(this.quantile(data, 0.75) * 100) / 100,
          high: Math.round(Math.max(...data) * 100) / 100,
          color: this.colors[module]
        })
        index += 1
      }
      series[1].data = outliersData
      series[2].data = othersData
      return series
    },
    categories: function () {
      return this.modules.map((module) => this.$t(module))
    },
    options: function () {
      return {
        chart: {
          type: 'boxplot'
        },
        title: {
          text: ''
        },
        legend: {
          enabled: false
        },
        series: this.series,
        xAxis: {
          categories: this.categories
        },
        yAxis: {
          min: 0,
          startOnTick: false,
          title: {
            text: this.$t('t.co2e.per.capita')
          }
        }
      }
    }
  },
  methods: {
    randomValue () {
      let min = -500
      let max = 500
      let randomValue = Math.floor(Math.random() * (max - min + 1) + min)
      return Math.round((randomValue / 5000) * 100) / 100
    }
  }
}
</script>
